/* eslint-disable react/jsx-props-no-spreading */

import React from "react";
import {
  Footer,
  Header,
  NoJs,
  Cart,
  Theme,
  LoadingOverlay,
  KlaviyoScripts
} from "~components";
import cn from "classnames";
import { useAppContext } from "~hooks";
import { Helmet } from "react-helmet";
import "~styles/global.css";
import "~styles/customCursor.css";
import * as styles from "./styles.module.scss";

const Layout = ({ children, className, location }) => {
  const { globalSettings } = useAppContext();

  const pathsToHide = [`/slices/`];
  const hidePage = pathsToHide.includes(location.pathname);

  return (
    <>
      {hidePage && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}

      <NoJs />
      <Theme />
      <KlaviyoScripts />

      <Header
        menu={globalSettings?.menu}
        bannerText={globalSettings?.bannerText}
      />
      <Cart />

      <div className={cn(styles.container, className)}>{children}</div>

      <Footer settings={globalSettings?.footer} />

      <LoadingOverlay />
    </>
  );
};

export default Layout;
